import React, { Component } from "react";
import { Responsive, Grid, Icon } from "semantic-ui-react";


class PropertyDescription extends React.Component {
  constructor(props) {
    super(props);
  }

  renderInDesktop() {
    // let finishes = []
    // if(this.props.descData.finishes !== undefined){
    //   finishes =this.props.descData.finishes
    // }
    return (
      <div style={{ padding: "5rem 0rem" }}>
        <Grid columns={2}>
          <Grid.Column
            style={{
              padding: "50px"
            }}
          >
            <div
              style={{
                fontSize: "18px",
                lineHeight: "23px",
                fontFamily: "Lato",
                fontWeight:"200"
              }}
            >
              <div
                dangerouslySetInnerHTML={{
                  __html: this.props.descData.smallDesc
                }}
              />
            </div>
          </Grid.Column>
          <Grid.Column
            style={{
              padding: "50px"
            }}
          >
            <Grid columns={2}>
              {this.props.descData.finishes.map((data, index) => {
                return (
                    <Grid.Column>
                    <Icon name='check' size="small" /> <span 
                    style={{
                      fontFamily:"Lato",
                      fontWeight:300
                    }}
                    dangerouslySetInnerHTML={{ __html: data }} />
                    </Grid.Column>
                );
              })}
            </Grid>
          </Grid.Column>
        </Grid>
      </div>
    );
  }

  renderInTablet() {
    return (
      <div style={{ margin: "4rem 0rem" }}>
        <Grid columns={1}>
          <Grid.Column
            style={{
              padding: "0px 20px"
            }}
          >
            <div
              style={{
                fontSize: "18px",
                lineHeight: "23px",
                fontFamily: "Lato",
                fontWeight: 300
              }}
            >
              <div
                dangerouslySetInnerHTML={{
                  __html: this.props.descData.smallDesc
                }}
              />
            </div>
          </Grid.Column>
          <Grid.Column
            style={{
              padding: "20px"
            }}
          >
            <Grid columns={2}>
              {this.props.descData.finishes.map((data, index) => {
                return (
                  <Grid.Column>
                  <Icon name='check' size="small" /> <span 
                  style={{
                    fontFamily:"Lato",
                    fontWeight:300
                  }}
                  dangerouslySetInnerHTML={{ __html: data }} />
                  </Grid.Column>
                );
              })}
            </Grid>
          </Grid.Column>
        </Grid>
      </div>
    );
  }
  renderInMobile() {
    return (
      <div style={{ padding: "5rem 0rem" }}>
        <Grid columns={1}>
          <Grid.Column
            style={{
              padding: "0px 20px"
            }}
          >
            <div
              style={{
                fontSize: "18px",
                lineHeight: "23px",
                fontFamily: "Lato",
                fontWeight: 300
              }}
            >
              <div
                dangerouslySetInnerHTML={{
                  __html: this.props.descData.smallDesc
                }}
              />
            </div>
          </Grid.Column>
          <Grid.Column
            style={{
              padding: "20px"
            }}
          >
            <Grid columns={2}>
              {this.props.descData.finishes.map((data, index) => {
                return (
                  <Grid.Column key={index}>
                  <Icon name='check' size="small" /> <span 
                  style={{
                    fontFamily:"Lato",
                    fontWeight:300
                  }}
                  dangerouslySetInnerHTML={{ __html: data }} />
                  </Grid.Column>
                );
              })}
            </Grid>
          </Grid.Column>
        </Grid>
      </div>
    );
  }

  render() {
    return (
      <div>
        <Responsive {...Responsive.onlyMobile}>
          {this.renderInMobile()}
        </Responsive>
        <Responsive {...Responsive.onlyTablet}>
          {this.renderInTablet()}
        </Responsive>
        <Responsive {...Responsive.onlyComputer}>
          {this.renderInDesktop()}
        </Responsive>
      </div>
    );
  }
}
export default PropertyDescription;
